import quickFetch from 'quick-fetch';
export const fetchWithEarlyRequestHook = (requestName, fallbackFetch, successHandler) => {
  const earlyRequest = quickFetch.getRequestStateByName(requestName);
  if (earlyRequest) {
    return new Promise((resolve, reject) => {
      earlyRequest.whenFinished((...args) => {
        resolve(successHandler(...args));
        quickFetch.removeEarlyRequest(requestName);
      });
      earlyRequest.onError(() => {
        fallbackFetch().then(successHandler).then(resolve).catch(error => reject(error));
        quickFetch.removeEarlyRequest(requestName);
      });
    });
  }
  return fallbackFetch().then(successHandler);
};